<template>
  <md-tab :md-label="label">
    <md-content class="md-padding">
      <table class="table table-striped table-bordered">
        <tr>
          <th>Year</th>
          <th>Beg Balance</th>
          <th>Contribs</th>
          <th>Earnings</th>
          <th>Ending Balance</th>
        </tr>
        <tr v-for="(row, index) in data" :key="`${label}-${index}`">
          <td>{{ row.year }}</td>
          <td>{{ row.beg_balance | currency }}</td>
          <td>{{ row.contribs | currency }}</td>
          <td>{{ row.earnings | currency }}</td>
          <td>{{ row.ending_balance | currency }}</td>
        </tr>
      </table>
    </md-content>
  </md-tab>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
export default {
  name: "RoeDcBalanceTable",
  props: {
    label: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      require: true
    }
  }
};
</script>
